import(/* webpackMode: "eager" */ "/app/apps/eurodrive/app/[locale]/error.tsx");
